import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import RespuestaServidor from './RespuestaServidor';

const NotFound = () => {
  return (
    <RespuestaServidor
      titulo="404 - Página no encontrada"
      texto="Lo sentimos, la página que buscás no existe."
      icono={PriorityHighIcon}
      textoBoton="Volver"
      colorIcono="primary"
      paginaANavegar={-1}
    />
  );
};

export default NotFound;
